import React from 'react';
import { Field, FieldState } from '../types/generic';

/**
 * Add an error to field and set the error state to true
 *
 * @param field field to be modified
 * @param err the error to report
 */
export const addError = (field: Field, err: string): void => {
	if (field.errorText) {
		field.errorText.add(`\n${err}`);
	} else {
		field.errorText = new Set(err);
	}
	field.error = true;
};

/**
 * Handle update the field values held in state (ie destructuring props and modifying in place)
 *
 * @param name name of the field to modify
 * @param value value to set
 * @param fieldValues existing state variable
 * @param setFieldValues function used to modify state
 */
export const handleFieldValueUpdate = (
	name: string,
	value: string | number | boolean,
	fieldValues: FieldState,
	setFieldValues: (val: FieldState) => void
): void => {
	setFieldValues({
		...fieldValues,
		[name]: {
			...fieldValues[name],
			value,
			error: false,
		},
	});
};

/**
 * Set all field errors to empty & check that any fields marked as "required" have data entered
 *
 * @param fieldValues NON-STATE variable to be verified - modified in place. Duplicate state variables via destructuring before passing
 */
export const checkRequired = (fieldValues: FieldState): void => {
	Object.entries(fieldValues).forEach(([key, val]) => {
		fieldValues[key].errorText = new Set();

		// 0 (numerical entry) is valid, but "falsy"
		if (val.required && val.value !== 0 && !val.value) {
			addError(fieldValues[key], 'Field is required.');
		}
	});
};

export const getHelperText = (field: Field): React.ReactNode => {
	let helperText: string[] = [];

	if (field.error && field.errorText) {
		helperText = [...field.errorText];
	}
	if (field.helperText) {
		if (field.helperText instanceof Array) {
			helperText = [...helperText, ...field.helperText];
		} else {
			helperText = [...helperText, field.helperText];
		}
	}

	if (helperText.length > 1) {
		return (
			<>
				{helperText[0]}
				{helperText.slice(1).map((help) => (
					<React.Fragment key={`helper-text-${help}`}>
						<br></br>
						{help}
					</React.Fragment>
				))}
			</>
		);
	} else {
		return <>{helperText}</>;
	}
};
